import Bingo from './bingo/bingo.js'
import Login from './login.js'
import ForoEconomico from './foroeconomico/foroeconomico.js'
import EditorEventos from './Eventos/Editor.js'
import { useState, useEffect } from 'react'
import Barra from './barra.js'


const App = () => {

  const PORT_BACK = 8000
  const SERVER_URL = "https://inscripcion.ar:"

  const back = SERVER_URL + PORT_BACK + "/"

  const [token, setToken] = useState('')
  const [eventos, setEventos] = useState([])
  const [evento, setEvento] = useState(0)
  const [eventoData, setEventoData] = useState({})
  const [usuario, setUsuario] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(0)
  const [quien, setQuien] = useState({ rol: 0 })
  const [id, setID] = useState(0)
  const [cual, setCual] = useState(false)
  const [recargar, setRecargar] = useState(false)
  const formato_viejo = "flex flex-col w-screen h-screen bg-orange-200 overflow-hidden"
  const formato_nuevo = "flex flex-col w-screen h-screen bg-zinc-500 overflow-hidden"

  function login() {
    const values = {
      usuario: usuario,
      password: password
    }
    const data = {
      body: JSON.stringify(values),
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    }
    fetch(back + 'login', data)
      .then(response => response.json())
      .then(a => {
        if (a.rol === undefined) {

          setToken(a)
          var d = JSON.parse(window.atob(a.split('.')[1]))
          setQuien(d)
          setError(0)
          setID(d.id)
        }
        else {
          setQuien({ rol: 0 })
          setError(1)
        }
        setUsuario('')
        setPassword('')
      })
      .catch(function (error) {
        console.log("Hubo un problema con la petición Fetch:" + error.message)
        setError(2)
      })
  }

  useEffect(() => {
    const traer_eventos = () => {
      const data = {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        }
      }
      fetch(back + 'admin/traer_eventos', data)
        .then(response => response.json())
        .then(json => {
          setEventos(json)
          const cual = json.filter(a => a.id === quien.evento_id)

          if (cual.length) {
            setEvento(cual[0].id)
            setEventoData(cual[0])
          } else {
            setEvento(json[0].id)
            setEventoData(json[0])
          }
        })
    }
    traer_eventos()
  }, [token, recargar, back, id, quien.evento_id])




  return (<>
    <div className={formato_nuevo}>
      {quien.rol === 0 ?
        <Login
          usuario={usuario}
          setUsuario={setUsuario}
          password={password}
          setPassword={setPassword}
          error={error}
          login={login}
        />
        : ''}
      {!cual && quien.rol ? <Barra quien={quien} setEventoData={setEventoData} evento={evento} setEvento={setEvento} eventos={eventos} setCual={setCual} /> : ''}
      {!cual && quien.rol >= 1 && evento === 41 && <Bingo id={id} quien={quien} evento={eventoData} token={token} />}
      {!cual && quien.rol >= 1 && evento === 44 && <ForoEconomico id={id} quien={quien} evento={eventoData} token={token} />}

      {cual && quien.rol === 2 && <EditorEventos
        token={token}
        eventos={eventos}
        evento={evento}
        setCual={setCual}
        recargar={recargar}
        setRecargar={setRecargar}
        quien={quien} />}
    </div>
  </>)
}
export default App